import {
  AddProductsToCartButton,
  ProductPageAddToCartActionsRow,
} from '@graphcommerce/magento-product'
import { ProductWishlistChipDetail } from '@graphcommerce/magento-wishlist'
import { useProductPageContext } from '../../contexts/ProductPageContext'
import { ProductItemsFragment } from '../../graphql/ProductItems.gql'
import { OutOfStockSubscribe } from '../OutOfStockSubscribe/OutOfStockSubscribe'

export const AddToCartOrOutOfStockSubscribe = (props: {
  product: ProductItemsFragment
  loggedOutB2B: boolean
}) => {
  const { product, loggedOutB2B } = props
  const { stock_status, sku, uid } = product
  const { configurableUid, configuredStockStatus, configuredVariantUrl } = useProductPageContext()
  const outOfStockUid = configurableUid || uid

  // So there's 2 possible scenerario's here:
  // 1: We've landed on a Simple product or a Configurable product that has not yet been configured by the user.
  //      Simple product: configuredVariantUrl is not defined and wont every be
  //      Configurable product: configuredVariantUrl can be defined, but only once the customer has configured the product
  //      In both these cases, the product variable from props should be used.
  // 2: We've landed on a configurable product, that has been preconfigured (Or we landed on a configred productt and the user has made their selection)
  //      The productPageContext should now be populated with a configredVariantUrl
  //  So IF we have a configuredVariantUrl, we also should use configuredStockStatus
  // And if we DONT have a configuredVariantUrl we should use the stock_status from props.product
  const isInStockSimple = configuredVariantUrl !== '' && configuredStockStatus === 'IN_STOCK'
  const isInstockConfigurable = configuredVariantUrl === '' && stock_status === 'IN_STOCK'
  const canAdd = isInStockSimple || isInstockConfigurable

  return (
    <>
      {canAdd ? (
        <ProductPageAddToCartActionsRow product={product}>
          <AddProductsToCartButton
            disabled={loggedOutB2B}
            fullWidth
            sku={sku}
            variant='contained'
          />
          <ProductWishlistChipDetail {...product} />
        </ProductPageAddToCartActionsRow>
      ) : (
        <OutOfStockSubscribe
          productUid={outOfStockUid}
          wishlistButton={<ProductWishlistChipDetail {...product} />}
        />
      )}
    </>
  )
}
